import { c as _c } from "react/compiler-runtime";
import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";
import { IconCheck, IconMinus } from "@tabler/icons-react";
import { cn } from "../utils";
function Checkbox(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("group/checkbox peer relative flex size-4 shrink-0 cursor-pointer items-center justify-center rounded-[4px] border border-input bg-background transition-colors outline-none dark:bg-input/30", "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50", "aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary aria-invalid:data-[indeterminate]:border-primary dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40", "data-[checked]:border-primary data-[checked]:bg-primary data-[checked]:text-primary-foreground dark:data-[checked]:bg-primary", "data-[indeterminate]:border-primary data-[indeterminate]:bg-primary data-[indeterminate]:text-primary-foreground dark:data-[indeterminate]:bg-primary", "group-has-disabled/field:opacity-50 disabled:cursor-not-allowed disabled:opacity-50", "after:absolute after:-inset-x-3 after:-inset-y-2", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="absolute inset-0 flex items-center justify-center transition-none"><IconCheck className="size-[87.5%] text-background group-data-[indeterminate]/checkbox:hidden" /><IconMinus className="hidden size-[87.5%] text-background group-data-[indeterminate]/checkbox:block" /></CheckboxPrimitive.Indicator>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t1) {
    t3 = <CheckboxPrimitive.Root data-slot="checkbox" className={t1} {...props}>{t2}</CheckboxPrimitive.Root>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export { Checkbox };